import { render, staticRenderFns } from "./VersionSelector.vue?vue&type=template&id=2529167c&scoped=true"
import script from "./VersionSelector.vue?vue&type=script&lang=ts"
export * from "./VersionSelector.vue?vue&type=script&lang=ts"
import style0 from "./VersionSelector.vue?vue&type=style&index=0&id=2529167c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2529167c",
  null
  
)

export default component.exports